import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: "4cff4091-1d1b-488f-be82-62d272df48f2",
    authority: "https://login.microsoftonline.com/common",
    // clientSecret: "3UC8Q~P1~WXiJIj6DnnkFC4Tcwg2c0fL6NXTGdl~",
    // clientId: "YOUR_CLIENT_ID",             // Replace with Azure AD client ID
    // authority: "https://login.microsoftonline.com/YOUR_TENANT_ID", // Replace with your tenant ID
    redirectUri: "http://localhost:3000",
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;
